//component life cycle mount, update and unmount
import { useState } from "react";

const getIntialState=()=>{
  console.log("inside the complex operation");
  let sum=0;
  for(let i=0;i<1000;i++){
    sum+=i
  }
  return sum;
}

function App(){
  console.log("rendered");
  const [count, setCount]=useState(getIntialState);

  const increment=()=>{
    setCount(count+1);
  }
  return (
    <div className="App"> 
        <h1>{count}</h1>
        <button onClick={increment}>Increment</button>
    </div>
  )
}

export default App;